var map = {
	"./review-1.png": "0bf1",
	"./review-2.png": "6fc9",
	"./review-3.png": "35e6",
	"./review-4.png": "02f2",
	"./review-5.png": "6c2a",
	"./review-6.png": "e5c9",
	"./review-7.png": "d356",
	"./review-8.png": "d163",
	"./review-9.png": "124c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f785";